// src/review/ReviewPublicPage.js
import { fetchJson, fileUrl } from '../api';
import { useParams } from 'react-router-dom';
import { useState } from 'react';
import {
  Box,
  Typography,
  TextField,
  Button,
  Paper,
  CircularProgress,
} from '@mui/material';

export default function ReviewPublicPage() {
  const { slug } = useParams();
  const [password, setPassword] = useState('');
  const [checking, setChecking] = useState(false);
  const [error, setError] = useState('');
  const [revision, setRevision] = useState(null);

  const handleCheck = async () => {
    if (!password.trim()) {
      setError('Inserisci la password.');
      return;
    }
    setChecking(true);
    setError('');
    try {
      const data = await fetchJson(`/revisions/${slug}/auth`, {
        method: 'POST',
        body: JSON.stringify({ password }),
      });
      setRevision({ ...data, file_url: data.hls_url });
    } catch (e) {
      setRevision(null);
      setError(e?.message || 'Password errata o link scaduto');
    } finally {
      setChecking(false);
    }
  };

  if (!revision) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: 2,
          bgcolor: '#f6f7fb',
        }}
      >
        <Paper
          elevation={0}
          sx={{
            width: '100%',
            maxWidth: 520,
            p: 3,
            borderRadius: 4,
            border: '1px solid',
            borderColor: 'divider',
            boxShadow: '0 12px 40px rgba(0,0,0,0.10)',
          }}
        >
          <Typography variant="h5" sx={{ mb: 0.5, fontWeight: 700 }}>
            Accesso alla visione
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Inserisci la password ricevuta per accedere alla pagina di revisione.
          </Typography>

          <TextField
            type="password"
            label="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
            autoFocus
            onKeyDown={(e) => {
              if (e.key === 'Enter') handleCheck();
            }}
            sx={{ mb: 2 }}
          />
          <Button
            fullWidth
            size="large"
            variant="contained"
            onClick={handleCheck}
            disabled={checking}
            sx={{ borderRadius: 999, textTransform: 'none', fontWeight: 700 }}
          >
            {checking ? <CircularProgress size={20} /> : 'Accedi'}
          </Button>

          {error && (
            <Typography color="error" sx={{ mt: 2 }}>
              {error}
            </Typography>
          )}
        </Paper>
      </Box>
    );
  }

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f6f7fb', p: 2 }}>
      <Box sx={{ maxWidth: 980, mx: 'auto', pt: 2 }}>
        <Typography variant="h5" sx={{ mb: 0.5, fontWeight: 800 }}>
          Episodio {revision.episode_id} — {niceAudience(revision.audience || revision.target)}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Visione protetta da password. Non condividere questo link senza autorizzazione.
        </Typography>

        <Paper
          elevation={0}
          sx={{
            p: 2,
            borderRadius: 4,
            border: '1px solid',
            borderColor: 'divider',
            boxShadow: '0 12px 40px rgba(0,0,0,0.10)',
          }}
        >
          <Box sx={{ borderRadius: 3, overflow: 'hidden', bgcolor: '#000' }}>
            <video controls src={fileUrl(revision.file_url)} style={{ width: '100%', display: 'block' }} />
          </Box>
        </Paper>
      </Box>
    </Box>
  );
}

function niceAudience(a) {
  const map = {
    visione_interna: 'Visione interna',
    capo_progetto: 'Capo progetto',
    autori: 'Autori',
    produttore: 'Produttore',
    rete: 'Visione rete',
    curatore_editoriale: 'Curatore editoriale',
  };
  return map[a] || a;
}
